import { Controller } from "@hotwired/stimulus"
import List from "list.js"

export default class extends Controller {

  connect () {
    let options = {
      valueNames: [
        { name: 'name', attr: 'data-name' },
        'games',
        'minutes',
        { name: 'goals', attr: 'data-goals' },
        { name: 'own', attr: 'data-own' },
        { name: 'y-cards', attr: 'data-y-cards' },
        { name: 'r-cards', attr: 'data-r-cards' }
      ]
    }

    let userList = new List('stats', options)

    userList.sort("games", {
      order: "desc"
    })
  }
}
